import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ConfirmationButton } from '../../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import EntitiesList from '../../../common/components/EntitiesList';
import QuerySettingsForm from './SettingsForm';

export const QueryMode = {
	DEFAULT: 'default',
	LOAD: 'load',
	CREATE: 'create',
	UPDATE: 'update'
};

const QueryPopover = ({ className, buttonClassName, style,
	queries, selectedQuery, onSelectQuery, onSaveQuery, onDeleteQuery,
	onModeChange, mode, filters, t }) => {

	const headerStyle = {
		padding: 10,
		borderBottom: '1px solid rgba(26,54,126,.125)'
	};

	const bodyStyle = {
		padding: 10,
		minWidth: 200,
		maxHeight: 450,
		overflowY: 'auto'
	};

	let isChanged = true;
	if (selectedQuery && selectedQuery.query) {
		const currentFilterValues = Object.values(filters).reduce((acc, { fields }) => ({ ...acc, ...fields }), {});
		isChanged = Object.keys(currentFilterValues).some(key => currentFilterValues[key] !== selectedQuery.query[key]);
	}

	const defaultFiltersToInclude = Object.fromEntries(Object.keys(filters).map(key => [key, filters[key].include])); // { 'Centers': true, 'DateRange': false, ... }}

	const selectedFiltersToInclude = selectedQuery ? Object.fromEntries(Object.keys(filters).map(key => [key, Object.keys(filters[key].fields).some(field => selectedQuery.query[field] !== undefined)])) :
		defaultFiltersToInclude;

	return <div
		className={className}
		style={{
			...style,
			position: 'absolute',
			zIndex: 2000,
			backgroundColor: '#FFF',
			boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
			border: '1px solid #CCC',
			borderRadius: 4,
			marginTop: 5,
			maxWidth: 600
		}}>
		<div>
			{mode === QueryMode.DEFAULT && <div>
				{selectedQuery && <div style={headerStyle}>
					<h4>{selectedQuery.name} <button className='close' onClick={() => onSelectQuery(null)} title={t('SavedQuery_Remove')}><FontAwesomeIcon icon={faXmark} /></button></h4>
					{isChanged && <Button className='btn-primary btn-block' onClick={() => onModeChange(QueryMode.UPDATE)}>{t('SavedQuery_Update')}</Button>}
				</div>}
				<div style={bodyStyle}>
					<ul style={{ listStyle: 'none', paddingLeft: 0 }}>
						<li style={{ padding: 5 }}><Button className='btn-primary btn-block' onClick={() => onModeChange(QueryMode.LOAD)}>{t('SavedQuery_Load')} <FontAwesomeIcon icon={faChevronRight} /></Button></li>
						<li style={{ padding: 5 }}><Button className='btn-primary btn-block' enabled={isChanged} onClick={() => onModeChange(QueryMode.CREATE)}>{t('SavedQuery_Save')} <FontAwesomeIcon icon={faChevronRight} /></Button></li>
					</ul>
				</div>
			</div>
			}

			{mode === QueryMode.LOAD && <div>
				<div style={headerStyle}>
					<a onClick={() => onModeChange(QueryMode.DEFAULT)}><FontAwesomeIcon icon={faChevronLeft} /> {t('SavedQuery_Load')}</a>
				</div>
				<div style={bodyStyle}>
					<EntitiesList columns={
						[
							{ accessor: 'name' },
							{
								accessor: 'id',
								cell: (id, query) => <span>
									<Button className='btn-sm btn-primary' onClick={() => onSelectQuery(query)}>{t('Common_Load')}</Button> <ConfirmationButton btnClasses='btn-sm' onConfirmation={() => onDeleteQuery(query)} confirmationTitle={t('SavedQuery_DeleteConfirmationTitle')}
										confirmationMessage={t('SavedQuery_DeleteConfirmationMessage')} displayType='inline' icon={faTrash} />
								</span>
							}
						]} data={queries} />
				</div>
			</div>}

			{mode === QueryMode.CREATE && <div>
				<div style={headerStyle}><a onClick={() => onModeChange(QueryMode.DEFAULT)}><FontAwesomeIcon icon={faChevronLeft} /> {t('SavedQuery_Create')}</a></div>
				<div style={bodyStyle}>
					<QuerySettingsForm onSubmit={onSaveQuery} filters={filters} initialValues={defaultFiltersToInclude} />
					<div className='clearfix' />
				</div>
			</div>}

			{mode === QueryMode.UPDATE && selectedQuery && <div>
				<div style={headerStyle}><a onClick={() => onModeChange(QueryMode.DEFAULT)}><FontAwesomeIcon icon={faChevronLeft} /> {t('SavedQuery_Update')}</a></div>
				<div style={bodyStyle}>
					<QuerySettingsForm onSubmit={onSaveQuery} filters={filters} initialValues={{ id: selectedQuery.id, name: selectedQuery.name, ...selectedFiltersToInclude }} />
					<div className='clearfix' />
				</div>
			</div>}
		</div>
	</div >;
};

export default withTranslation()(QueryPopover);